import {CartItem, ServiceOffer, YsoProduct} from '../../../data/model';
import * as contextSelectors from '../../context-data/context-data.selectors';
import {CommerceErrorInterface} from '../../error-handling';
import {Store} from '@ngrx/store';
import {Injectable} from '@angular/core';
import {ContextData} from '../../context-data';

export interface PageAttributeExtraInfo {
  depth4?: string;
}

@Injectable({providedIn: 'root'})
export abstract class AnalyticsService {
  protected contextData: ContextData;
  private firstLoad = true;

  constructor(protected store: Store) {
    this.setupContextDataSubscription();
  }

  private setupContextDataSubscription(): void {
    this.store.select(contextSelectors.selectContextData).subscribe(context => {
      if (!context) return;
      this.contextData = context;
      if (this.firstLoad) {
        this.sessionStart();
        this.firstLoad = false;
      }
    });
  }

  abstract sessionStart(): void;

  abstract pageView(pageName: string | undefined): void;

  abstract cartAction(cartItem: CartItem, action: string): void;

  abstract checkoutStep(): void;

  abstract clickEvent(action: string): void;

  abstract viewProductDetails(offer: ServiceOffer | YsoProduct): void;

  abstract applicationError(error?: CommerceErrorInterface): void;
}
